module.exports = __webpack_public_path__ + "img/my-life-journal-WI30grRfBnE-unsplash.d152d27d.jpg";